import { FC } from 'react';

import { SemanticAspectCard } from '@/components/SemanticAspectCard';
import { SemanticModelResult } from '@/hooks/dbtStrategy/useSemanticModel';

type SemanticModel = Omit<SemanticModelResult, 'applied'> | null;

interface DimensionsViewProps {
  resource: SemanticModel;
}

const useDimensions = (resource: SemanticModel) => {
  if (resource?.definition == null) return null;
  if (resource.definition.__typename !== 'SemanticModelDefinitionNode') return [];
  const dimensions = resource.definition.dimensions;
  return dimensions?.map((dimension) => ({
    name: dimension?.name ?? null,
    description: dimension?.description ?? null,
    type: dimension?.type ?? null,
  }));
};

export const DimensionsView: FC<DimensionsViewProps> = ({ resource }) => {
  const dimensions = useDimensions(resource);

  if (dimensions == null) {
    return <div className="mt-10 text-fgDecorative">Loading...</div>;
  }

  if (!dimensions.length) {
    return <div className="mt-10 text-fgDecorative">No dimensions found.</div>;
  }

  return (
    <ul aria-label="Dimensions" className="mt-10 space-y-2">
      {dimensions.map((dimension, index) => {
        return (
          <SemanticAspectCard {...dimension} key={dimension?.name ?? `${index}`} />
        );
      })}
    </ul>
  );
};
